import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { disabled } from '../../state/operations/copy-edge';
import copy_edge_svg from '../../../assets/img/SVG_icons/Top/editing_model/clone_edge.svg';
import { img } from '@phi/components';
import { clone_edge } from '@frontend/geometry_and_math';
import CopyEdgetooltip from './CopyEdgeTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const CopyEdgeIcon = copy_edge_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Copy Edge';
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (disabled.value)
                return;
            else
                clone_edge();
        },
    },

    render() {
        return h(BarButton, {
            id: 'clone-edge-button',
            onClick: this.onClick,
            disabled: disabled.value,
            active: false,
            selected: this.state.tut_stage === 7,
            tippy: 'bottom',
            help: 'clone_edge',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(copy_edge_svg, this.alt),
            tooltip: CopyEdgetooltip,
        });
    },
});
